import React, { useEffect, useState } from 'react';
import {
  Home,
  Briefcase,
  Users,
  Star,
  MessageSquare,
  Settings,
  Bell,
  ChevronDown,
  Phone,
  Video,
  MessageCircle,
  Eye,
  UserCheck,
  Play,
  MoreHorizontal,
  ChevronRight,
  Grid3X3,
  UserPen,
  Building2,
  CreditCard,
  Plus,
  RefreshCw,
  SquarePen,
  MessageSquareMore,
  TrendingUp,
  X,
  Mail as MailIcon, 
  Phone as PhoneIcon,
  CheckCircle,
  FileText,
  Lock,
  Trash2,
  User,
  Award
} from "lucide-react";
import { useNavigate } from 'react-router-dom';
import "./Dashboard.css"
import EmployerNavbar from '../../Pages/Navbar/EmployerNavbar';
import BaseUrl from '../../ApiServices/BaseUrl';
import Swal from 'sweetalert2';
import Footer from '../../Footer/Footer';

const EmployeeDashboard = () => {
  const [planName, setPlanName] = useState("No Active Plan");
  const [planStartDate, setPlanStartDate] = useState(null);
  const [planEndDate, setPlanEndDate] = useState(null);
  const [subscriptionStatus, setSubscriptionStatus] = useState("Inactive");
  const [loadingPlan, setLoadingPlan] = useState(true);
  const [shortlistedCandidates, setShortlistedCandidates] = useState([]);
  const [loadingShortlisted, setLoadingShortlisted] = useState(true);
  const [jobListings, setJobListings] = useState([]);
  const [loadingJobs, setLoadingJobs] = useState(true);
  const [repostingJobId, setRepostingJobId] = useState(null);
  const [applications, setApplications] = useState([]);
  const [recentViews, setRecentViews] = useState([]);
  const [loadingRecentViews, setLoadingRecentViews] = useState(true);
  const [showPopup, setShowPopup] = useState(true);
  const [profileViewers, setProfileViewers] = useState([]);
  const [viewersLoading, setViewersLoading] = useState(true);
  const [currentFeatures, setCurrentFeatures] = useState([]);

  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem('user')) || {};
  const userId = user.id;

  const formatDate = (date) => {
    if (!date) return "N/A";
    return new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
  };

  const hasEmployerRepostAccess = () => {
    return currentFeatures.some(
      (feature) => feature.feature_key === 'employer_job_repost_access' && feature.is_enabled
    );
  };

  const isPremiumPlan = () => {
    const normalizedPlan = String(planName || '').toLowerCase();
    return normalizedPlan.includes('silver') || normalizedPlan.includes('gold') || normalizedPlan.includes('premium');
  };

  const getRepostCooldownEnd = (item) => {
    const lastRepostedAt = item?.last_reposted_at || item?.reposted_at;
    if (!lastRepostedAt) return null;

    const nextAvailableAt = new Date(lastRepostedAt);
    if (Number.isNaN(nextAvailableAt.getTime())) return null;

    nextAvailableAt.setDate(nextAvailableAt.getDate() + 7);
    return nextAvailableAt;
  };

  const isInRepostCooldown = (item) => {
    const nextAvailableAt = getRepostCooldownEnd(item);
    return !!nextAvailableAt && nextAvailableAt > new Date();
  };

  const formatJobPosition = (value) => {
    if (!value) return "Not specified";

    if (Array.isArray(value)) {
      return value.filter(Boolean).join(", ") || "Not specified";
    }

    if (typeof value === "string") {
      const trimmed = value.trim();
      if (!trimmed) return "Not specified";

      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) {
          return parsed.filter(Boolean).join(", ") || "Not specified";
        }
        if (typeof parsed === "string") {
          return parsed || "Not specified";
        }
      } catch (error) {
        // Keep original string when it's not JSON.
      }

      return trimmed.replace(/^\[|\]$/g, "").replace(/"/g, "") || "Not specified";
    }

    return String(value);
  };

  const getJobStatusMeta = (status) => {
    const normalizedStatus = String(status || "").trim().toLowerCase();

    if (normalizedStatus === "approved" || normalizedStatus === "active") {
      return {
        label: "Approved",
        badgeClass: "bg-success text-white"
      };
    }

    if (normalizedStatus.includes("pending")) {
      return {
        label: "Pending",
        badgeClass: "bg-warning text-dark"
      };
    }

    return {
      label: status || "Pending",
      badgeClass: "bg-warning text-dark"
    };
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const handlePostNewJobFromDashboard = async () => {
    try {
      console.log('Fetching latest temporary_id...');
      const response = await fetch(`${BaseUrl}/api/employer/get/latest-temporary-id`);

      if (!response.ok) {
        console.error('Failed to fetch temporary ID. Status:', response.status);
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('API Response:', data);

      const latestTemporaryId = data.latest_temporary_id;
      const newTemporaryId = latestTemporaryId ? Number(latestTemporaryId) + 1 : 1;

      console.log('Navigating to /basicinfo with temporaryId:', newTemporaryId);
      navigate('/basicinfo', { state: { temporaryId: newTemporaryId } });
    } catch (err) {
      console.error('Error in handlePostNewJobFromDashboard:', err);
      navigate('/basicinfo', { state: { temporaryId: 1 } });
    }
  };

  const handlePopupPostJob = async () => {
    try {
      console.log('Fetching latest temporary_id...');
      const response = await fetch(`${BaseUrl}/api/employer/get/latest-temporary-id`);

      if (!response.ok) {
        console.error('Failed to fetch temporary ID. Status:', response.status);
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('API Response:', data);

      const latestTemporaryId = data.latest_temporary_id;
      const newTemporaryId = latestTemporaryId ? Number(latestTemporaryId) + 1 : 1;

      console.log('Navigating to /basicinfo with temporaryId:', newTemporaryId);
      setShowPopup(false);
      navigate('/basicinfo', { state: { temporaryId: newTemporaryId } });
    } catch (err) {
      console.error('Error in handlePopupPostJob:', err);
      setShowPopup(false);
      navigate('/basicinfo', { state: { temporaryId: 1 } });
    }
  };

  const fetchRecentViews = async () => {
    if (!userId) {
      setRecentViews([]);
      setLoadingRecentViews(false);
      return;
    }

    try {
      setLoadingRecentViews(true);
      const response = await fetch(`${BaseUrl}/employer-recent/${userId}?limit=10`);
      if (!response.ok) throw new Error('Failed to fetch recent views');

      const data = await response.json();
      setRecentViews(data.views || []);
    } catch (error) {
      console.error('Error fetching recent views:', error);
      setRecentViews([]);
    } finally {
      setLoadingRecentViews(false);
    }
  };

  const fetchProfileViewers = async () => {
    if (!userId) {
      setProfileViewers([]);
      setViewersLoading(false);
      return;
    }

    try {
      setViewersLoading(true);
      const response = await fetch(`${BaseUrl}/api/profile-viewers/${userId}?limit=20`);
      if (!response.ok) throw new Error('Failed to fetch profile viewers');

      const data = await response.json();
      setProfileViewers(data.data || []);
    } catch (error) {
      console.error('Error fetching profile viewers:', error);
      setProfileViewers([]);
    } finally {
      setViewersLoading(false);
    }
  };

  const fetchEmployerFeatures = async () => {
    if (!userId) {
      setCurrentFeatures([]);
      return;
    }

    try {
      const response = await fetch(`${BaseUrl}/api/employer/subscription/current/${userId}`);
      if (!response.ok) return;

      const data = await response.json();
      setCurrentFeatures(data.features || []);
    } catch (error) {
      console.error('Error fetching employer features:', error);
    }
  };

  useEffect(() => {
    const fetchDashboardSummary = async () => {
      if (!userId) {
        setLoadingPlan(false);
        setLoadingShortlisted(false);
        setLoadingJobs(false);
        return;
      }

      try {
        setLoadingPlan(true);
        setLoadingShortlisted(true);
        setLoadingJobs(true);

        const response = await fetch(`${BaseUrl}/api/employer/dashboard-summary/${userId}`);
        if (!response.ok) throw new Error("Failed to fetch dashboard summary");
        
        const data = await response.json();
        
        if (data.success) {
          // 1. Set Subscription Details
          setPlanName(data.subscription?.plan_name || "No Active Plan");
          setPlanStartDate(data.subscription?.start_date || null);
          setPlanEndDate(data.subscription?.expiry_date || null);
          setSubscriptionStatus(data.subscription?.status 
            ? data.subscription.status.charAt(0).toUpperCase() + data.subscription.status.slice(1) 
            : "Inactive");
          
          // 2. Set Shortlisted Candidates
          const enrichedShortlisted = (data.shortlisted || []).map(shortlisted => ({
            ...shortlisted,
            candidate_details: {
              email: shortlisted.candidate_email,
              phone: shortlisted.candidate_phone,
              whatsapp_number: shortlisted.candidate_whatsapp
            },
            profile_photo: shortlisted.profile_photo
              ? `${BaseUrl}${shortlisted.profile_photo}`
              : null,
            shortlisted_job_id: shortlisted.job_id,
            shortlisted_job_title: shortlisted.linked_job_title || shortlisted.job_title || 'Not specified',
            job_position: formatJobPosition(shortlisted.job_position),
            nationality: shortlisted.nationality || 'Not specified',
            age: shortlisted.age || 'Not specified',
            total_experience: shortlisted.total_work_experience || 'Not specified',
            current_location: shortlisted.current_country || 'Not specified'
          }));
          setShortlistedCandidates(enrichedShortlisted);

          // 3. Set Job Listings
          setJobListings(data.jobListings || []);
        }
      } catch (error) {
        console.error("Error fetching dashboard summary:", error);
      } finally {
        setLoadingPlan(false);
        setLoadingShortlisted(false);
        setLoadingJobs(false);
      }
    };

    fetchDashboardSummary();
    fetchRecentViews();
    fetchProfileViewers();
    fetchEmployerFeatures();
  }, [userId]);

  useEffect(() => {
    const fetchJobListings = async () => {
      if (!userId) {
        setLoadingJobs(false);
        return;
      }

      try {
        const response = await fetch(
          `${BaseUrl}/api/employer/by-user?user_id=${userId}`
        );

        if (response.status === 404) {
          setJobListings([]);
          return;
        }

        if (!response.ok) {
          throw new Error("Failed to fetch job listings");
        }

        const data = await response.json();
        setJobListings(data || []);
      } catch (error) {
        console.error("Error fetching job listings:", error);
        setJobListings([]);
      } finally {
        setLoadingJobs(false);
      }
    };

    fetchJobListings();
  }, [userId]);

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/applications?empuserid=${userId}`);

        if (!response.ok) {
          throw new Error("Failed to fetch applications");
        }

        const data = await response.json();
        setApplications(data || []);
      } catch (error) {
        console.error("Error fetching applications:", error);
        setApplications([]);
      }
    };

    fetchApplications();
  }, [userId]);

  const handleViewProfile = (candidate) => {
    if (candidate.user_id && candidate.first_name) {
      navigate(`/candidateview/${candidate.user_id}/${candidate.first_name}`);
    } else {
      console.error('Missing user_id or first_name for navigation');
    }
  };

  const candidateViewProfile = (profile) => {
    if (profile.candidate_user_id && profile.first_name) {
      navigate(`/candidateview/${profile.candidate_user_id}/${profile.first_name}`);
    } else {
      console.error('Missing candidate_user_id or first_name for navigation');
    }
  };

  const handleEditJob = (job, e) => {
    e.stopPropagation();
    navigate('/basicinfo', {
      state: {
        temporaryId: job.temporary_id,
        isEditing: true,
        jobData: job
      }
    });
  };

  const handleRepostJob = async (job, e) => {
    e.stopPropagation();

    const status = String(job?.status || '').trim().toLowerCase();
    if (status === 'pending verification' || status === 'pending') {
      Swal.fire('Info', 'Job not verified yet.', 'info');
      return;
    }

    if (!hasEmployerRepostAccess()) {
      Swal.fire({
        icon: 'info',
        title: 'Upgrade Required',
        text: 'Repost is not enabled in your current employer plan.',
        confirmButtonText: 'View Plans'
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/subscriptionplans');
        }
      });
      return;
    }

    if (isInRepostCooldown(job)) {
      const nextAvailableAt = getRepostCooldownEnd(job);
      Swal.fire(
        'Info',
        `This job is already reposted. It can be reposted again after ${nextAvailableAt?.toLocaleString('en-IN')}.`,
        'info'
      );
      return;
    }

    try {
      setRepostingJobId(job.id);
      const response = await fetch(`${BaseUrl}/api/employer/${job.id}/repost`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId })
      });

      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(
          data?.next_available_at
            ? `This job is already reposted. It can be reposted again after ${new Date(data.next_available_at).toLocaleString('en-IN')}.`
            : data?.error || 'Failed to repost job'
        );
      }

      setJobListings((prev) =>
        prev.map((item) =>
          item.id === job.id
            ? {
                ...item,
                reposted_at: data?.job?.reposted_at || new Date().toISOString(),
                last_reposted_at: data?.job?.last_reposted_at || new Date().toISOString()
              }
            : item
        )
      );

      Swal.fire('Success', 'Job reposted successfully.', 'success');
    } catch (error) {
      Swal.fire('Error', error.message || 'Failed to repost job', 'error');
    } finally {
      setRepostingJobId(null);
    }
  };

  return (
    <>
      <EmployerNavbar />

      {/* Popup Modal */}
      {showPopup && (
        <div className="employer-popup-overlay">
          <div className="employer-popup-container">
            <button className="employer-popup-close-btn" onClick={handleClosePopup}>
              <X size={20} />
            </button>

            <div className="employer-popup-content">
              <div className="employer-popup-header">
                <h2 className="employer-popup-title">Gulf Worker</h2>
                <p className="employer-popup-subtitle">Connecting Talent with Opportunity</p>
              </div>

              <div className="employer-popup-right">
                <div className="popup-highlight-section">
                  <h3 className="popup-highlight-title">Start Hiring Today</h3>
                  <button
                    className="employer-popup-post-btn"
                    onClick={handlePopupPostJob}
                  >
                    <span className="popup-plus-icon">+</span>
                    Post New Job
                  </button>
                  <p className="popup-time-info">It takes less than 2 minutes</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Main Content */}
      <main className={`employee-main ${showPopup ? 'popup-active' : ''}`} style={{ backgroundColor: '#f0f2f5', minHeight: '100vh', padding: '24px' }}>
        
        {/* Stats Cards Row - Job Seeker Style */}
        <div className="row g-3 mb-4 employer-stat-grid">
          <div className="col-6 col-md-3">
            <div className="emp-stat-card" style={{
              background: 'linear-gradient(135deg, #f6d365 0%, #fda085 100%)',
              borderRadius: '12px',
              color: '#fff',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <p className="emp-stat-label">ACTIVE JOBS</p>
              <h2 className="emp-stat-value">{jobListings.filter(j => j.status === 'Active').length}</h2>
              <p className="emp-stat-meta">
                <Briefcase size={13} style={{ marginRight: '4px' }} /> Total Posted: {jobListings.length}
              </p>
            </div>
          </div>
          <div className="col-6 col-md-3">
            <div className="emp-stat-card" style={{
              background: 'linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%)',
              borderRadius: '12px',
              color: '#fff',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <p className="emp-stat-label">APPLICATIONS</p>
              <h2 className="emp-stat-value">{applications.filter(app => jobListings.some(job => Number(job.id) === Number(app.jobid))).length}</h2>
              <p className="emp-stat-meta">
                {'>'} Track Applications
              </p>
            </div>
          </div>
          <div className="col-6 col-md-3">
            <div className="emp-stat-card" style={{
              background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
              borderRadius: '12px',
              color: '#fff',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <p className="emp-stat-label">SHORTLISTED</p>
              <h2 className="emp-stat-value">{shortlistedCandidates.length}</h2>
              <p className="emp-stat-meta">
                <UserCheck size={13} style={{ marginRight: '4px' }} /> Candidates Selected
              </p>
            </div>
          </div>
          <div className="col-6 col-md-3">
            <div className="emp-stat-card" style={{
              background: 'linear-gradient(135deg, #7f53ac 0%, #647dee 100%)',
              borderRadius: '12px',
              color: '#fff',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <p className="emp-stat-label">PROFILE VIEWS</p>
              <h2 className="emp-stat-value">{profileViewers.length}</h2>
              <p className="emp-stat-meta">
                <Eye size={13} style={{ marginRight: '4px' }} /> Who viewed you
              </p>
            </div>
          </div>
        </div>

        {/* Second Row: Viewed Profiles & Interested Candidates */}
        <div className="row g-3 mb-3">
          {/* Left Column: Viewed Profiles & CVs */}
          <div className="col-lg-6">
            <div className="dashboard-section p-3">
              <div className="section-header mb-3">
                <h4 className="section-title m-0"><Eye size={20} /> Viewed Profiles & CVs</h4>
                <span className="view-all-btn" onClick={() => navigate('/candidates')} style={{ cursor: 'pointer' }}>View All</span>
              </div>
              <div className="scrollable-table-container">
                <div className="table-responsive">
                  <table className="applied-jobs-table">
                    <thead>
                      <tr>
                        <th>Candidate</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>View Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loadingRecentViews ? (
                        <tr><td colSpan="5" className="text-center text-muted py-4">Loading...</td></tr>
                      ) : recentViews.length === 0 ? (
                        <tr><td colSpan="5" className="text-center text-muted py-4">No profiles viewed yet.</td></tr>
                      ) : (
                        recentViews.map((profile) => (
                          <tr key={profile.id}>
                            <td
                              className="cursor-pointer"
                              onClick={() => candidateViewProfile(profile)}
                              title="View Profile"
                            >
                              <div className="fw-bold text-dark">{profile.candidate_name || 'Unknown'}</div>
                              <div className="small text-muted">{formatJobPosition(profile.job_position)}</div>
                            </td>
                            <td>
                              <a href={`mailto:${profile.email || ''}`} className="email-link-btn" title={profile.email || 'N/A'}>
                                <MailIcon size={18} />
                              </a>
                            </td>
                            <td>
                              <a href={`tel:${profile.phone || ''}`} className="phone-link-btn" title={profile.phone || 'N/A'}>
                                <PhoneIcon size={18} />
                              </a>
                            </td>
                            <td>{formatDate(profile.viewed_at)}</td>
                            <td>
                              <button 
                                className="cancel-app-btn"
                                style={{ color: '#2e7d32', backgroundColor: '#e8f5e9', borderColor: '#c8e6c9' }}
                                onClick={() => candidateViewProfile(profile)}
                              >
                                View
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column: Interested & Shortlisted */}
          <div className="col-lg-6">
            <div className="dashboard-section p-3">
              <div className="section-header mb-3">
                <h4 className="section-title m-0"><UserCheck size={20} /> Interested & Shortlisted</h4>
                <span className="view-all-btn" onClick={() => navigate('/appliedcandidates')} style={{ cursor: 'pointer' }}>View All</span>
              </div>
              <div className="scrollable-table-container">
                <div className="table-responsive">
                  <table className="applied-jobs-table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>WP</th>
                        <th>Position</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loadingShortlisted ? (
                        <tr><td colSpan="5" className="text-center text-muted py-4">Loading...</td></tr>
                      ) : shortlistedCandidates.length === 0 ? (
                        <tr><td colSpan="5" className="text-center text-muted py-4">No candidates shortlisted yet.</td></tr>
                      ) : (
                        shortlistedCandidates.map((candidate, idx) => (
                          <tr key={candidate.id || idx}>
                            <td
                              className="cursor-pointer"
                              onClick={() => handleViewProfile(candidate)}
                              title="View Profile"
                            >
                              <div className="fw-bold text-dark">{candidate.first_name ? candidate.first_name.split('@')[0] : 'Unknown'}</div>
                              <div className="small text-muted">{formatJobPosition(candidate.job_position)}</div>
                            </td>
                            <td>
                              <a href={`mailto:${candidate.candidate_details?.email || ''}`} className="email-link-btn" title={candidate.candidate_details?.email || 'N/A'}>
                                <MailIcon size={18} />
                              </a>
                            </td>
                            <td>
                              <a href={`tel:${candidate.candidate_details?.phone || ''}`} className="phone-link-btn" title={candidate.candidate_details?.phone || 'N/A'}>
                                <PhoneIcon size={18} />
                              </a>
                            </td>
                            <td>
                              <a href={`https://wa.me/${candidate.candidate_details?.whatsapp_number || ''}`} className="phone-link-btn" title={candidate.candidate_details?.whatsapp_number || 'N/A'} target="_blank" rel="noopener noreferrer">
                                <MessageCircle size={18} />
                              </a>
                            </td>
                            <td
                              className={candidate.shortlisted_job_id ? "cursor-pointer text-primary fw-semibold" : ""}
                              onClick={() => {
                                if (candidate.shortlisted_job_id) {
                                  navigate(`/viewjobdetails/${candidate.shortlisted_job_id}`);
                                }
                              }}
                              title={candidate.shortlisted_job_id ? "View Job Details" : ""}
                            >
                              {candidate.shortlisted_job_title || 'Not specified'}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Third Row: My Job Listings - Full Width */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="dashboard-section p-3">
              <div className="section-header mb-3">
                <h4 className="section-title m-0"><Briefcase size={20} /> My Job Listings</h4>
                <button 
                  className="apply-btn-sm" 
                  onClick={handlePostNewJobFromDashboard}
                >
                  <Plus size={16} className="me-1" /> Post New Job
                </button>
              </div>
              <div className="scrollable-table-container">
                <div className="table-responsive">
                  <table className="applied-jobs-table employer-job-listings-table">
                    <thead>
                      <tr>
                        <th className="job-listing-title-col">Job Title</th>
                        <th className="job-listing-status-col">Status</th>
                        <th className="text-center job-listing-applications-col">Applications</th>
                        <th className="text-end job-listing-actions-col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loadingJobs ? (
                        <tr><td colSpan="4" className="text-center text-muted py-4">Loading job listings...</td></tr>
                      ) : jobListings.length === 0 ? (
                        <tr><td colSpan="4" className="text-center text-muted py-4">No job listings found.</td></tr>
                      ) : (
                        jobListings.map((job) => {
                          const jobStatusMeta = getJobStatusMeta(job.status);

                          return (
                          <tr key={job.id}>
                            <td className="cursor-pointer job-listing-title-cell" onClick={() => navigate(`/viewjobdetails/${job.id}`)}>
                              <div className="d-flex align-items-center gap-3 job-listing-title-wrap">
                                {job.profile_photo ? (
                                  <img 
                                    src={`${BaseUrl}${job.profile_photo}`} 
                                    alt={job.job_title} 
                                    style={{ width: '45px', height: '45px', borderRadius: '10px', objectFit: 'cover', border: '1px solid #eee' }}
                                  />
                                ) : (
                                  <div style={{ width: '45px', height: '45px', borderRadius: '10px', background: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #eee' }}>
                                    <Briefcase size={20} className="text-muted" />
                                  </div>
                                )}
                                <div className="job-listing-title-content">
                                  <div className="fw-bold text-dark job-listing-title-text">{job.job_title || job.job_type || "No Title"}</div>
                                  <div className="small text-muted job-listing-location-text">
                                    {[job.working_city, job.state_or_province, job.country].filter(Boolean).join(', ') || 'Location N/A'}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="job-listing-status-cell">
                              <span className={`badge job-listing-status-badge ${jobStatusMeta.badgeClass}`}>
                                {jobStatusMeta.label}
                              </span>
                            </td>
                            <td className="text-center job-listing-applications-cell">
                              <div className="d-flex flex-column align-items-center">
                                <span className="fw-bold fs-5" style={{ color: '#3d6e6e', lineHeight: '1' }}>{applications.filter(app => Number(app.jobid) === Number(job.id)).length}</span>
                                <span style={{ fontSize: '9px', textTransform: 'uppercase', color: '#94a3b8', fontWeight: '600' }}>Applicants</span>
                              </div>
                            </td>
                            <td className="text-end job-listing-actions-cell">
                              <div className="d-flex justify-content-end gap-2">
                                <button 
                                  className="action-btn-styled"
                                  style={{ backgroundColor: '#198754', color: 'white', position: 'relative' }}
                                  onClick={(e) => { e.stopPropagation(); navigate('/employer-messages'); }}
                                  title="Messages"
                                >
                                  <div className="d-flex align-items-center gap-2">
                                    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                      <MessageSquareMore size={16} />
                                      {/* Mock notification dot - in real app, check for unread messages */}
                                      {job.unread_messages_count > 0 && (
                                        <span style={{ position: 'absolute', top: '-4px', right: '-4px', width: '8px', height: '8px', backgroundColor: '#ff4d4d', borderRadius: '50%', border: '1px solid white' }}></span>
                                      )}
                                    </div>
                                    <span className="d-none d-md-inline" style={{ fontSize: '12px', fontWeight: '600' }}>Messages</span>
                                  </div>
                                </button>

                                {(job.status === "Active" || job.status === "Approved") && (
                                  <button 
                                    className="action-btn-styled"
                                    style={{ backgroundColor: '#70a1ff', color: 'white' }}
                                    onClick={(e) => handleRepostJob(job, e)} 
                                    disabled={repostingJobId === job.id} 
                                    title={isInRepostCooldown(job) ? 'Cooldown active' : 'Repost Job'}
                                  >
                                    <div className="d-flex align-items-center gap-2">
                                      {repostingJobId === job.id ? '...' : <RefreshCw size={14} />}
                                      <span className="d-none d-md-inline" style={{ fontSize: '12px', fontWeight: '600' }}>Reposted</span>
                                    </div>
                                  </button>
                                )}

                                <button 
                                  className="action-btn-styled" 
                                  style={{ backgroundColor: '#007bff', color: 'white' }}
                                  onClick={(e) => handleEditJob(job, e)}
                                  title="Edit Job"
                                >
                                  <div className="d-flex align-items-center gap-2">
                                    <SquarePen size={14} />
                                    <span className="d-none d-md-inline" style={{ fontSize: '12px', fontWeight: '600' }}>Edit</span>
                                  </div>
                                </button>

                                <button 
                                  className="action-btn-styled"
                                  style={{ backgroundColor: '#dc3545', color: 'white' }}
                                  title="Delete Job"
                                >
                                  <Trash2 size={14} />
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Fourth Row: Profile Viewers & Wallet/Plan */}
        <div className="row g-3 mb-3">
          {/* Left Column: See Who Viewed Your Profile */}
          <div className="col-lg-8">
            <div className="dashboard-section p-3">
              <div className="section-header mb-3">
                <h4 className="section-title m-0">
                  <Eye size={20} /> See Who Viewed Your Profile
                </h4>
                {!isPremiumPlan() && <span className="badge bg-warning text-dark" style={{ borderRadius: '6px', fontSize: '10px' }}>Premium</span>}
              </div>
              
              <div style={{ position: 'relative' }}>
                {!isPremiumPlan() ? (
                  <div style={{ position: 'relative' }}>
                    <div style={{ filter: 'blur(4px)', opacity: 0.4 }} className="scrollable-table-container">
                      <table className="applied-jobs-table">
                        <thead>
                          <tr>
                            <th className="sno-col">S.No</th>
                            <th className="name-col">Viewer Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>User Type</th>
                            <th>Date & Time</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {[1, 2, 3].map(i => (
                            <tr key={i}>
                              <td className="sno-col">{i}</td>
                              <td className="fw-bold name-col">Sample Candidate</td>
                              <td><button className="email-link-btn" disabled><MailIcon size={14} /></button></td>
                              <td><button className="phone-link-btn" disabled><PhoneIcon size={14} /></button></td>
                              <td><span className="badge bg-light text-dark">Job Seeker</span></td>
                              <td>18 Mar 2026, 10:30 AM</td>
                              <td><button className="apply-btn-sm" disabled>View</button></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 10, textAlign: 'center', background: 'rgba(255,255,255,0.95)', padding: '30px', borderRadius: '20px', boxShadow: '0 10px 40px rgba(0,0,0,0.1)', border: '1px solid #e2e8f0', width: '80%', maxWidth: '400px' }}>
                      <div style={{ background: '#fef3f2', width: '60px', height: '60px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 15px' }}>
                        <Lock size={30} style={{ color: '#dc2626' }} />
                      </div>
                      <h5 className="fw-bold mb-2">Unlock Profile Viewers</h5>
                      <p className="text-muted mb-4 small">Upgrade to Silver or Gold plan to see which candidates are interested in your company and viewing your profile.</p>
                      <button className="recharge-btn py-2" onClick={() => navigate('/subscriptionplans')}>Upgrade Plan Now</button>
                    </div>
                  </div>
                ) : (
                  <div className="scrollable-table-container">
                    <table className="applied-jobs-table">
                      <thead>
                        <tr>
                          <th className="sno-col">S.No</th>
                          <th className="name-col">Viewer Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>User Type</th>
                          <th>Date & Time</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {viewersLoading ? (
                          <tr><td colSpan="7" className="text-center py-4 bg-white text-muted">Loading profile viewers...</td></tr>
                        ) : profileViewers.length === 0 ? (
                          <tr><td colSpan="7" className="text-center py-4 bg-white text-muted">No profile viewers yet</td></tr>
                        ) : (
                          profileViewers.map((viewer, index) => (
                            <tr key={viewer.id}>
                              <td className="sno-col">{index + 1}</td>
                              <td className="fw-bold name-col">{viewer.viewer_name_resolved || 'Anonymous User'}</td>
                              <td>
                                {viewer.viewer_email_resolved && (
                                  <a href={`mailto:${viewer.viewer_email_resolved}`} className="email-link-btn" title={viewer.viewer_email_resolved}>
                                    <MailIcon size={14} />
                                  </a>
                                )}
                              </td>
                              <td>
                                {viewer.viewer_phone_resolved && (
                                  <a href={`tel:${viewer.viewer_phone_resolved}`} className="phone-link-btn" title={viewer.viewer_phone_resolved}>
                                    <PhoneIcon size={14} />
                                  </a>
                                )}
                              </td>
                              <td>
                                <span className="badge bg-light text-dark" style={{ textTransform: 'capitalize' }}>
                                  {(viewer.viewer_user_type || 'User').replace('_', ' ')}
                                </span>
                              </td>
                              <td>{new Date(viewer.viewed_at).toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</td>
                              <td>
                                <button className="apply-btn-sm" onClick={() => navigate(`/candidates/${viewer.viewer_user_id}`)}>View</button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Right Column: Wallet & Plan Details */}
          <div className="col-lg-4">
            <div className="dashboard-section wallet-card h-100 p-3">
              <div className="section-header mb-3">
                <h4 className="section-title m-0"><CreditCard size={20} /> Wallet & Plan</h4>
                <div 
                  className="cursor-pointer" 
                  onClick={() => navigate('/subscriptionplans')}
                  title="Plan History"
                >
                  <TrendingUp size={18} className="text-muted" />
                </div>
              </div>

              <div className="wallet-stats">
                {/* Plan Info Card */}
                <div className="wallet-stat-item">
                  <div className="wallet-stat-icon" style={{ color: '#0ea5e9', background: '#e0f2fe', padding: '8px', borderRadius: '10px' }}>
                    <Award size={20} />
                  </div>
                  <div className="wallet-stat-info">
                    <div className="wallet-stat-value">{planName || 'Free'}</div>
                    <div className="wallet-stat-label">{subscriptionStatus || 'Inactive'}</div>
                  </div>
                </div>

                {/* CV Views Card */}
                <div className="wallet-stat-item">
                  <div className="wallet-stat-icon" style={{ color: '#f59e0b', background: '#fef3c7', padding: '8px', borderRadius: '10px' }}>
                    <Eye size={20} />
                  </div>
                  <div className="wallet-stat-info">
                    <div className="wallet-stat-value">12 / 50</div>
                    <div className="wallet-stat-label">CV Views</div>
                  </div>
                </div>

                {/* Call Unlocks Card */}
                <div className="wallet-stat-item">
                  <div className="wallet-stat-icon" style={{ color: '#10b981', background: '#d1fae5', padding: '8px', borderRadius: '10px' }}>
                    <Phone size={20} />
                  </div>
                  <div className="wallet-stat-info">
                    <div className="wallet-stat-value">3 / 10</div>
                    <div className="wallet-stat-label">Calls</div>
                  </div>
                </div>

                {/* WhatsApp Card */}
                <div className="wallet-stat-item">
                  <div className="wallet-stat-icon" style={{ color: '#25d366', background: '#dcfce7', padding: '8px', borderRadius: '10px' }}>
                    <MessageCircle size={20} />
                  </div>
                  <div className="wallet-stat-info">
                    <div className="wallet-stat-value">6 / 20</div>
                    <div className="wallet-stat-label">WhatsApp</div>
                  </div>
                </div>
              </div>

              <div className="mt-auto">
                <div className="p-3 mb-4" style={{ background: '#f8fafc', borderRadius: '16px', border: '1px dashed #e2e8f0' }}>
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <span className="text-muted small">Valid Until</span>
                    <span className="fw-bold small text-dark">{formatDate(planEndDate)}</span>
                  </div>
                  <div className="progress" style={{ height: '6px', borderRadius: '10px' }}>
                    <div className="progress-bar bg-success" style={{ width: '65%' }}></div>
                  </div>
                </div>
                
                <button className="recharge-btn mb-1" onClick={() => navigate('/subscriptionplans')}>
                  Upgrade Plan
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default EmployeeDashboard;
